import React from 'react';
import PropTypes from 'prop-types';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import styles from './PublicLayout.css';

function PublicLayout({children}) {
    return (
        <div className={styles.root}>
            <Header className={styles.header} />
            {children}
            <Footer className={styles.footer} />
        </div>
    );
}

PublicLayout.propTypes = {
    children: PropTypes.any.isRequired
};

export {
    PublicLayout
};
